let parameters = {
    chartDataSource: {
        label: 'Table Data',
        class: 'xs12 sm12 d-flex',
        type: 'select',
        source: 'dataSources',
        itemValue: 'id',
        itemText: 'name',
        items: [],
        item: {data: [], headers: []},
        wait: false
    },
    selectedColumns: {
        label: 'Selected Fields',
        source: 'parameters.never',
        items: [],
        types: [],
        class: 'xs12 sm12 d-flex',
        type: '_hidden',
        value: [],
        display: false,
        wait: false
    },
    searchFormDesign: {
      label: 'Search Form Design ',
      class: 'xs12 sm12 d-flex',
      type: 'select',
      source: 'parameters.searchFormDesign.items',
      itemText: 'name',
      itemValue: 'id',
      item: {},
      items: [
        {id: 'none', name: 'None'},
        {id: 'top', name: 'Top'},
        {id: 'left', name: 'Left'}
      ],
      wait: false,
      value: null
    },
    searchFormSchema: {
      label: 'Search Form Schema',
      class: 'xs12 sm12',
      type: 'textarea',
      value: ""
    },
    topButtonMenu: {
      label: 'Top Button Menu',
      class: 'xs12 sm12',
      type: 'textarea',
      value: ""
    },
    rowLevelMenu: {
      label: 'Menu Items (Row)',
      class: 'xs12 sm12',
      type: 'textarea',
      value: ""
    },
    downloadable: {
      label: 'Downloadable',
      class: 'xs12 sm6',
      type: 'switch',
      source: 'parameters.never',
      itemValue: 'format',
      value: true,
      items: [],
      item: {
        data: [],
        headers: []
      },
    },
    searchable: {
      label: 'Searchable',
      class: 'xs12 sm6',
      type: 'switch',
      source: 'parameters.never',
      itemValue: 'format',
      value: true,
      items: [],
      item: {
        data: [],
        headers: []
      },

    },
    showHeaders: {
      label: 'Show Headers',
      class: 'xs12 sm6',
      type: 'switch',
      source: 'parameters.never',
      itemValue: 'format',
      value: true,
      items: [],
      item: {
        data: [],
        headers: []
      },
    },
    autoSelect: {
      label: 'Auto Select',
      class: 'xs12 sm6',
      type: 'switch',
      source: 'parameters.never',
      itemValue: 'format',
      value: false,
      items: [],
      item: {
        data: [],
        headers: []
      },
    },
    autoRefresh: {
      label: 'Auto Refresh',
      class: 'xs12 sm6',
      type: 'switch',
      source: 'parameters.never',
      itemValue: 'format',
      value: false,
      items: [],
      item: {
        data: [],
        headers: []
      },
    },
    serverSide: {
      label: 'Server Side',
      class: 'xs12 sm6',
      type: 'switch',
      source: 'parameters.never',
      itemValue: 'format',
      value: false,
      items: [],
      item: {
        data: [],
        headers: []
      },
    },
    rowsPerPage: {
        label: 'Rows Per Page',
        source: 'parameters.never',
        items: [],
        types: [],
        class: 'xs12 sm12 d-flex',
        type: 'input',
        value: '20',
        display: true,
        wait: false
    },
    tableThemeDesign: {
      label: 'Search Form Design ',
      class: 'xs12 sm12 d-flex',
      type: 'select',
      source: 'parameters.tableThemeDesign.items',
      itemText: 'name',
      itemValue: 'id',
      item: {},
      items: [
        {id: 'none', name: 'None'},
        {id: 'round', name: 'Round Search'},
        {id: 'box', name: 'Box Search'}
      ],
      wait: false,
      value: 'none'
    },
    tableTitle: {
      groupId: 'design',
      label: 'Table Title',
      source: 'parameters.never',
      items: [],
      types: [],
      item: {data: [], headers: []},
      class: 'xs12 sm12 d-flex',
      type: 'code',
      value: '',
      display: false,
      wait: false,
      lang: 'html',
    },
    rowIconColor: {
      groupId: 'design',
      label: 'Row Icon Color',
      class: 'xs12 sm12 d-flex',
      type: 'colorPicker',
      multiple: false,
      value: '#2196f3',
      wait: false
  }
};

export default parameters;
